import axios from "axios";
import config from "../../../../settings/config";
import { handleError } from "../../../../network/servicErrorHandling";

async function create_media(params) {
  return Promise.resolve().then((v) =>
    axios
      .post(`${config.baseUrl}v1/medias/`, params)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

async function get_custom_product(uid, id) {
  return Promise.resolve().then((v) =>
    axios
      .get(`${config.baseUrl}v1/shops/${uid}/product-requests/${id}`)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

async function rejectCustomProduct(uid, id, params) {
  return Promise.resolve().then((v) =>
    axios
      .patch(`${config.baseUrl}v1/shops/${uid}/product-requests/${id}`, params)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

export { create_media, get_custom_product, rejectCustomProduct };
